import { render, staticRenderFns } from "./widgetSslVpnUserList.vue?vue&type=template&id=72f9e957&scoped=true&"
import script from "./widgetSslVpnUserList.vue?vue&type=script&lang=js&"
export * from "./widgetSslVpnUserList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f9e957",
  null
  
)

export default component.exports